module.exports = __webpack_public_path__ + "img/ico_ranking_moter.2167421b.svg";